import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ExternalEndpoints } from './Constants';
import RequestHelper from './RequestHelper';
export default {
  sendSupportMessage: function () {
    var _sendSupportMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(bodyParams) {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiPost({
                baseUrl: ExternalEndpoints.CUSTOMER_SUPPORT_BASE_URL,
                endpoint: ExternalEndpoints.CUSTOMER_SUPPORT_ENDPOINT,
                headers: {
                  'Content-Type': 'application/json'
                },
                body: bodyParams,
                raw: true
              }, false);

            case 3:
              callResponse = _context.sent;

              if (!(callResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw Error("[sendSupportMessage response] ".concat(callResponse.error));

            case 6:
              return _context.abrupt("return", callResponse);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function sendSupportMessage(_x) {
      return _sendSupportMessage.apply(this, arguments);
    }

    return sendSupportMessage;
  }()
};